var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"align-center px-md-10 py-6 py-md-10 py-lg-16"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }